import React, { useState, useEffect, useContext } from 'react'
import { Flex, Box, Image, Text } from 'theme-ui'
import { useStaticQuery, graphql } from 'gatsby'

import ProductCounter from '../../components/product/ProductCounter'

import {
  getConvertedPrices,
  getTryNowAttr,
} from '../../hooks/useShopifyFunctions'
import formatPrice from '../../utils/formatPrice'
import strings from './strings.json'

import StyledHeading from '../shared/Typography/Heading/Heading'

const { cartItemPriceLabel, cartItemAriaRemoveFromCart } = strings

const LineItem = props => {
  const currency = props.currency

  const {
    lineItem,
    decreaseProductAmount,
    increaseProductAmount,
    removeItem,
    setCartHasItems,
  } = props
  const { quantity, title, variant, id, customAttributes } = lineItem
  const isTryNowItem = getTryNowAttr(customAttributes)
  const { convertedPrice, convertedCompareAtPrice } = getConvertedPrices(
    customAttributes
  )

  const { selectedOptions } = variant

  const [imageSrc, setImageSrc] = useState()
  const [altText, setAltText] = useState()
  const [options, setOptions] = useState()
  const [showVariants, setShowVariants] = useState()

  const priceVariant = variant.price

  useEffect(() => {
    if (variant.image != null) {
      const { src, text } = variant.image
      setImageSrc(src)
      setAltText(text)
    }
  }, [variant.image])

  useEffect(() => {
    setOptions(selectedOptions)
    setShowVariants(
      selectedOptions.length > 0 &&
        selectedOptions[0].name !== 'Title' &&
        selectedOptions[0].values !== 'Default Title'
    )
  }, [selectedOptions])
  const currenPriceVal =
    typeof convertedPrice === 'string' || !convertedPrice
      ? priceVariant
      : convertedPrice

  const displayPrice = formatPrice(Number(currenPriceVal), undefined, currency)
  return (
    <React.Fragment>
      <Flex
        sx={{
          flexDirection: ['row'],
          position: 'relative',
          py: '10px',
        }}
        {...props}
      >
        <Box sx={{ width: ['90px'], paddingTop: 10 }}>
          {imageSrc ? (
            <Image
              src={imageSrc}
              alt={altText}
              sx={{ objectFit: 'contain', width: '100%' }}
            />
          ) : (
            <>no image</>
          )}
        </Box>

        <Flex sx={{ flex: 2, p: '8px', flexDirection: 'column' }}>
          <Box>
            <StyledHeading as="h6">{title}</StyledHeading>
            <Text variant="body2">
              {showVariants ? (
                <Flex>
                  {options.map((option, index) => {
                    return `${option.value}${
                      index + 1 < options.length ? ', ' : ''
                    }`
                  })}
                </Flex>
              ) : (
                ''
              )}
            </Text>
            {isTryNowItem && (
              <Text
                sx={{
                  color: 'green',
                  fontSize: 0,
                  fontWeight: 'semiBold',
                  letterSpacing: '1.5px',
                  py: '5px',
                }}
              >
                Try at Home for Free
              </Text>
            )}
          </Box>

          <Box sx={{ my: '4px', maxWidth: 80 }}>
            <ProductCounter
              currentAmount={quantity}
              decreaseAmount={() =>
                decreaseProductAmount({ id, quantity, tryNow: isTryNowItem })
              }
              increaseAmount={() =>
                increaseProductAmount({ id, quantity, tryNow: isTryNowItem })
              }
            />
          </Box>
          {/* <Text
            onClick={() => removeItem(id, setCartHasItems)}
            sx={{ p: '3px', fontSize: '9px', color: 'red', cursor: 'pointer' }}
          >
            REMOVE
          </Text> */}
        </Flex>

        <Flex sx={{ flex: 1, justifyContent: 'flex-end', p: '8px' }}>
          <Text aria-label={cartItemPriceLabel} sx={{ fontWeight: 'semiBold' }}>
            {!isTryNowItem ? (
              displayPrice
            ) : (
              <Text>
                $0{' '}
                <Text
                  as="span"
                  sx={{ fontSize: 0, fontWeight: 'normal' }}
                >{`(${displayPrice} if kept)`}</Text>{' '}
              </Text>
            )}
          </Text>
        </Flex>
      </Flex>
    </React.Fragment>
  )
}

export default LineItem
